/**
 * Every named analytics event in the recruiter app.
 *
 * Add new events here (and to the analytics plan) instead of passing free-text names to
 * `track()`. Events must never carry candidate data: no candidate or application IDs, no
 * names, no note or message text. Only the kind of action and a few non-personal details.
 */
export const AnalyticsEvents = {
  // Job board
  CANDIDATE_OPENED: 'candidate_opened',
  CANDIDATES_SORTED: 'candidates_sorted',
  CANDIDATES_LOAD_MORE_CLICKED: 'candidates_load_more_clicked',
  STATISTICS_OPENED: 'statistics_opened',
  JOB_PIN_TOGGLED: 'job_pin_toggled',

  // Candidate screening
  CANDIDATE_RATED: 'candidate_rated',
  CANDIDATE_STATUS_CHANGED: 'candidate_status_changed',
  CANDIDATE_NAVIGATED: 'candidate_navigated',
  INTERVIEW_READ_OPENED: 'interview_read_opened',
  ANSWER_AUDIO_PLAYED: 'answer_audio_played',
  SHAREABLE_SUMMARY_OPENED: 'shareable_summary_opened',
  SUMMARY_PDF_DOWNLOADED: 'summary_pdf_downloaded',
  CV_DOWNLOADED: 'cv_downloaded',
  CANDIDATE_FILTER_APPLIED: 'candidate_filter_applied',
  // Answer filter (counts and stage only, never question or answer text)
  ANSWER_FILTER_OPENED: 'answer_filter_opened',
  ANSWER_FILTER_CLOSED: 'answer_filter_closed',
  ANSWER_FILTER_RESULT: 'answer_filter_result',
  ANSWER_FILTER_UNAVAILABLE: 'answer_filter_unavailable',

  // Candidate profile and statistics
  NOTE_ADDED: 'note_added',
  STATISTICS_FILTER_CHANGED: 'statistics_filter_changed',

  // Navigation and help
  PINNED_JOB_OPENED: 'pinned_job_opened',
  HELP_CENTER_OPENED: 'help_center_opened',
  SUPPORT_CHAT_OPENED: 'support_chat_opened',

  // Outreach
  CANDIDATES_EXPORTED: 'candidates_exported',
  CANDIDATE_CSV_EXPORTED: 'candidate_csv_exported',

  // Search (lengths and counts only, never the search text)
  SEARCH_PERFORMED: 'search_performed',
  SEARCH_RESULT_OPENED: 'search_result_opened',
  SEARCH_ABANDONED: 'search_abandoned',

  // Errors
  ERROR_SHOWN: 'error_shown',
} as const;

export type AnalyticsEvent = (typeof AnalyticsEvents)[keyof typeof AnalyticsEvents];

/** Only simple, non-personal values are allowed as event properties. */
export type AnalyticsProperties = Record<string, string | number | boolean | undefined>;
